import React, { useState, useEffect, Component } from 'react';
import { Dimensions, Platform, StyleSheet, Text, View, TouchableOpacity, Button, Image, Alert, BackHandler } from 'react-native';
import { Camera } from 'expo-camera';
import * as ImagePicker from 'expo-image-picker';
import * as ImageManipulator from 'expo-image-manipulator';
import { useNavigation } from '@react-navigation/native';
import { SwiperFlatList } from 'react-native-swiper-flatlist';
import * as Location from 'expo-location';
import { manipulateAsync, FlipType, SaveFormat } from 'expo-image-manipulator';
import { Ionicons, MaterialIcons, FontAwesome, Fontisto } from '@expo/vector-icons';
import CustomAlert from './CustomAlert';
import { ActivityIndicator } from 'react-native-paper';
import { apiFetch } from '../modules/api';

export default function App() {


  const [selectedImage, setSelectedImage] = useState(null);
  const [alertText, setAlertText] = useState("");
  const [alertVisible, setAlertVisible] = useState(false);
  const [onAcceptAlert, setOnAcceptAlert] = useState(null);
  const [onCancelAlert, setOnCancelAlert] = useState(null);
  const [exit, setExit] = useState(false);
  const [navigationDispatch, setNavigationDispatch] = useState({});
  const [isLoadingCamera, setIsLoadingCamera] = useState(false);

  useEffect(
    () =>
      navigation.addListener('beforeRemove', (e) => {
        console.log("preventCamera");
        setExit(true);
        e.preventDefault();
        setNavigationDispatch(e);
        /*
        setOnAcceptAlert(() => () => {navigation.dispatch(e.data.action)});
        setOnCancelAlert(() => () => resetAlert());*/
      }),
    [navigation]
  );

  useEffect(() => {
    if (exit && navigationDispatch?.data) {
      setTimeout(() => {
        navigation.dispatch(navigationDispatch.data.action);
      }, 500);
    }
  }, [exit, navigationDispatch])

  const openImagePickerAsync = async () => {
    const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (permissionResult.granted === false) {
      alert("Se requieren permisos para accesar al carrete de fotos!");
      return;
    }

    const pickerResult = await ImagePicker.launchImageLibraryAsync();
    if (pickerResult.canceled === true) {
      return;
    }


    gFoto = await manipulateAsync(
      pickerResult.assets[0].uri, [

    ],
      {
        compress: 1,
        format: ImageManipulator.SaveFormat.JPEG,
        aspect: [4, 3],
        base64: true,
      });


    setImage(pickerResult.assets[0].uri);
    setSelectedImage({ localUri: pickerResult.assets[0].uri });
    origenFoto = "galeria";
  };



  const navigation = useNavigation();

  const recargar = () => {

    navigation.replace(
      'FotoProducto',
      null,
      null,
    );

  }
  const [zoom, setZoom] = useState(0);


  async function checkCameraPermission() {
      if (!navigator.permissions) {
        console.warn("Permissions API no disponible en este navegador");
        return;
      }

      try {
        const result = await navigator.permissions.query({ name: "camera" });

        if (result.state === "denied") {
          alert("No tienes permiso para usar la cámara.");
          navigation.goBack()
        }

        // Si quieres reaccionar a cambios:
        result.onchange = () => {
          if (result.state === "denied") {
            alert("Se bloqueó el permiso de cámara.");
            navigation.goBack()
          }
        };

      } catch (e) {
        console.log("No se pudo consultar el permiso de cámara:", e);
      }
    }

  useEffect(function () {

    gPantalla = "";
    let mounted = true;
    checkCameraPermission();
    async function obtenerFotos() {

      if (mounted) {

        if (gMostrarFoto != 'si') {

          gFoto1 = "";

          const datos = '{"determinante" : "' + gDeterminante + '","operador" : "' + gOperador + '","upc" : "' + gUpc + '","tipo" : "upc"}'
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: datos
          }

          const response = await apiFetch(gApiPath + "/api/listarFotos", requestOptions);
          const json = await response.json();

          if (json.estatus == "bien") {

            var listadoFotos = json.datos;

            gFotoid = {};

            for (var i = 0; i < listadoFotos.length; i++) {

              var ruta = gApiPathFoto + listadoFotos[i].imagen;
              gFotoid[ruta] = listadoFotos[i].id;

              if (gFoto1 === "") {
                gFoto1 = ruta;

              }



            }


          }
        };


        (async () => {
          setHasCameraPermission(true);
          setHasGalleryPermission(true)
        })();
      }

    }
    obtenerFotos();


    return () => mounted = false
  }, []);

  function regresar() {
    gMostrarFoto = "no";
    gVerFoto = "";
    recargar();
  }



  function carrete_lleno() {

    if (gFoto1 == "") {

      global.carreteLleno = false;


    } else {

      global.carreteLleno = true;

    }





    return global.carreteLleno;


  }

  const [errorMsg, setErrorMsg] = useState(null);

  /*async function validarGpsEncendido(){

    let { status } = await Location.requestForegroundPermissionsAsync();
    
        if (status !== 'granted') {
            setErrorMsg('Permission to access location was denied');
            gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
            showAlert();
            navigation.navigate("Acceso");
            return;
        }else{
          let location = await Location.watchPositionAsync(
            {accuracy:Location.Accuracy.High,
            timeInterval:5000,
            distanceInterval:10
          },
            (loc) => {
              gGeo = loc.coords;
            }
            );
        }
  }*/

  async function grabarImagenes() {
    setErrorMsg(null);
    let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      navigation.navigate("Acceso");
      return;
    }

    /* try{
     var altitude = gGeo.altitude
     var latitude = gGeo.latitude
     var longitude = gGeo.longitude
     }catch{
 
       validarGpsEncendido();
 
     }  */

    var altitude = ""
    var latitude = ""
    var longitude = ""
    //const compressedBase64 = compressBase64(gFoto.base64);

    // console.log("Base 64: " +  gFoto.base64);
    // console.log("=================================================================================================");
    // console.log("Comprimido: " +  compressedBase64);
    // console.log("=================================================================================================");

    let datos = '{"tipo" :"upc",' + '"imagen" : "' + gFoto.base64 + '", operador : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "' + gUpc + '","altitude":"' + altitude + '","latitude":"' + latitude + '","longitude":"' + longitude + '","origen":"' + origenFoto + '"}'
    let requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    };

    const response = await apiFetch(gApiPath + "/api/guardarFoto", requestOptions);
    const json = await response.json();
    await deletePicture();
    gVerFoto = "";
    recargar();

  }

  async function eliminarImagen(f) {

    var idDelete = gFotoid[gVerFoto];
    gFotoid[gVerFoto] = 0;

    switch (gVerFoto) {
      case gFoto1:
        gFoto1 = "";
        break;
    }

    let datos = '{"id" : "' + idDelete + '"}';
    let requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos

    };

    const response = await apiFetch(gApiPath + "/api/borrarFotoPromo", requestOptions);
    const json = await response.json();
    gMostrarFoto = "no";
    recargar();

  }


  async function rotarFoto() {


    global.gFoto = await manipulateAsync(
      gFoto.uri, [
      { rotate: 90 },
    ],
      {


        compress: 1,
        format: ImageManipulator.SaveFormat.JPEG,
        aspect: [2, 1.5],
        base64: true,
        autoFocus: false,
      });
    setImage(gFoto.uri);
  }

  function alertEliminar(f) {
    setAlertText("¿Desea eliminar la imagen seleccionada?");
    setOnAcceptAlert(() => () => eliminarImagen(f));
    setOnCancelAlert(() => () => setAlertVisible(false));
    setAlertVisible(true);
  }

  const fotos = [

    gFoto1,


  ];


  function verFoto(f) {

    gMostrarFoto = 'si';
    gVerFoto = f;

    recargar();

  }


  async function agregarFoto(f) {

    if (gFoto1 == "") {
      gFoto1 = f
    };

    await grabarImagenes();
  }

  const [hasCameraPermission, setHasCameraPermission] = useState(true);
  const [hasGalleryPermission, setHasGalleryPermission] = useState(null);
  const [camera, setCamera] = useState(null);
  const [image, setImage] = useState(null);
  const [pictureSize, setPictureSize] = useState(null);
  const [type, setType] = useState(Camera.Constants.Type.back);

  const getBestPictureSize = async () => {
    if (!camera?.getAvailablePictureSizesAsync) {
      return null;
    }

    const parseArea = (size) => {
      const [width, height] = size.split('x').map(Number);
      if (!Number.isFinite(width) || !Number.isFinite(height)) {
        return 0;
      }
      return width * height;
    };

    // Prefer 4:3 because it usually maps to full sensor resolution.
    const ratioCandidates = ['4:3', '16:9'];

    for (const ratio of ratioCandidates) {
      try {
        const sizes = await camera.getAvailablePictureSizesAsync(ratio);
        if (sizes?.length) {
          return [...sizes].sort((a, b) => parseArea(b) - parseArea(a))[0];
        }
      } catch (error) {
        // Continue with next ratio when this one is unsupported.
      }
    }

    return null;
  };

  const getWebVideoConstraints = () => {
    if (Platform.OS !== 'web') {
      return undefined;
    }

    return {
      facingMode: type === Camera.Constants.Type.back ? 'environment' : 'user',
      width: { ideal: 1920 },
      height: { ideal: 1080 },
    };
  };

  const prepararPictureSize = async () => {
    const highestRes = await getBestPictureSize();
    if (highestRes) {
      setPictureSize(highestRes);
      console.log('pictureSize seleccionada:', highestRes);
    }
  };

  const takePicture = async () => {
    if (camera) {
      origenFoto = "app";
      const data = await camera.takePictureAsync({
        quality: 1,
        skipProcessing: false,
        base64: true,
      });

      console.log('captura tomada:', { width: data.width, height: data.height, pictureSize });

      gFoto = await manipulateAsync(
        data.uri, [
      ],
        {
          compress: 1,
          format: ImageManipulator.SaveFormat.JPEG,
          base64: true,
        });
      setImage(data.uri);
    }
  }



  const deletePicture = async () => {
    if (image) {
      //await FileSystem.deleteAsync(image, { idempotent: true });
      setImage(null)
    }
  }

  async function addPicture() {
    if (image) {
      origenFoto = "app";
      agregarFoto(gFoto.uri);
    }
  }

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Image,
      allowsEditing: true,
      aspect: [1, 1],
      quality: 1,
      base64: true,

    });

    if (!result.canceled) {
      setImage(result.assets[0].uri);
    }

  };
  if (hasCameraPermission === null || hasGalleryPermission === false) {
    return <View />;
  }
  if (hasCameraPermission === false || hasGalleryPermission === false) {
    return <Text>Sin Acceso a la camara</Text>;
  }

  const handleChangeCamera = () => {
    setIsLoadingCamera(true);
    setTimeout(() => {
      setType(
        type === Camera.Constants.Type.back
          ? Camera.Constants.Type.front
          : Camera.Constants.Type.back
      );
    }, 2000);
  };

  useEffect(() => {
    setIsLoadingCamera(false);
  }, [type]);


  return (

    <View style={styles.container}>
      <CustomAlert alertVisible={alertVisible} setAlertVisible={setAlertVisible} text={alertText} onAccept={onAcceptAlert} onCancel={onCancelAlert} />
      <View style={styles.cameraContainer}>

        {(gMostrarFoto === 'no') ?
          (image) ?
            <Image source={{ uri: image }} style={styles.camera} /> :
            (!exit && !isLoadingCamera) ?
                <Camera ref={ref => setCamera(ref)} style={styles.camera} type={type} zoom={zoom} ratio="4:3" pictureSize={pictureSize || undefined} onCameraReady={prepararPictureSize} videoConstraints={getWebVideoConstraints()} /> :
              <></>
          : <></>}
        {(gMostrarFoto === 'no') ?
          (image) ?

            <View style={{ marginVertical: "15%", bottom: "5%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
              <TouchableOpacity onPress={() => deletePicture()} style={{ paddingRight: 60 }}>
                <Ionicons name="md-arrow-back-circle-sharp" size={54} color="white" />
              </TouchableOpacity>
              <TouchableOpacity onPress={() => addPicture()}>
                <Ionicons name="ios-add-circle-sharp" size={74} color="white" />
              </TouchableOpacity>
              <TouchableOpacity onPress={() => rotarFoto(gFoto)} style={{ paddingLeft: 60 }}>
                <Fontisto name="spinner-refresh" size={54} color="white" />
              </TouchableOpacity>
            </View>

            : (carrete_lleno()) ?
              <View style={{ bottom: "20%", paddingTop: "10%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}></View>
              :

              <View style={{ bottom: "20%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                {/*<TouchableOpacity  onPress={openImagePickerAsync}  style={{  paddingRight:60}}>
                  <FontAwesome name="file-image-o" size={44} color="black" />
                </TouchableOpacity>*/}
                {!isLoadingCamera ? (
                  <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                    <View >
                      <TouchableOpacity onPress={() => takePicture()} >
                        <FontAwesome name="camera" size={44} color="white" style={styles.shadow} />
                      </TouchableOpacity>
                    </View>
                    <View style={{ marginLeft: 60, height: 42, ...styles.shadow, borderRadius: 10 }}>
                      <TouchableOpacity onPress={() => {
                        handleChangeCamera();
                      }}>
                        <Ionicons name="camera-reverse-sharp" size={54} color="white" style={{ top: -8, height: 50 }} />
                      </TouchableOpacity>
                    </View>
                  </View>
                ) : (
                  <ActivityIndicator animating={true} size={'large'} color={'white'} />
                )}
              </View>
          : null}

        {(gMostrarFoto === 'no') ? (image) ? null :
          <>{/*<View style={{ flexDirection: 'row', marginVertical: "15%", bottom: "15%" }}>
            <Text style={styles.textLabels}>Zoom</Text>
            <Slider
              style={{ width: "70%", height: 40 }}
              thumbTintColor={theme.colors.primary}
              minimumValue={0}
              maximumValue={1}
              minimumTrackTintColor="#fff"
              maximumTrackTintColor="#fff"
              onValueChange={value => setZoom(value)}
            />
          </View>*/}</>

          : null}

        {gMostrarFoto === 'si' ? <Image source={{ uri: gVerFoto }} style={styles.camera} /> : null}
        {(gMostrarFoto === 'si') ?
          <View style={{ marginVertical: "17%", bottom: "5%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
            <TouchableOpacity onPress={() => regresar()} style={{ paddingRight: 60 }}>
              <Ionicons name="md-arrow-back-circle-sharp" size={54} color="white" />
            </TouchableOpacity>
            <TouchableOpacity onPress={() => alertEliminar(gFoto.uri)} style={{ paddingLeft: 60 }}>
              <MaterialIcons name="delete-forever" size={54} color="white" />
            </TouchableOpacity>
          </View> : null}

      </View>

      <View style={styles.container2}>

        <SwiperFlatList
          data={fotos}

          renderItem={({ item }) => (

            <View style={styles.child}>

              <TouchableOpacity onPress={() => item != '' ? verFoto(item) : null}>
                <Image source={item === '' ? { uri: gApiPathFoto + 'xxxzzzppp.jpg' } : { uri: item }} style={{ width: 90, height: 60, alignItems: 'center', justifyContent: 'center' }} />

              </TouchableOpacity>
            </View>

          )}
        />
      </View>

    </View>
  );
}
const { width } = Dimensions.get('screen');
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignContent: 'center',
    backgroundColor: '#000'
  },
  camera: {
    height: "80%",
    width: "100%",
  },
  cameraContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    top: "5%",
    backgroundColor: '#000'
  },
  button: {
    flex: 1,
  },
  tomarFoto: {
    width: "20%",
    height: 50,
    borderRadius: 70,
    alignItems: 'center',
    justifyContent: 'center'
  }, container2: {
    height: "10%",
    width: '100%',
  },

  child: {
    alignSelf: 'center',
    resizeMode: 'contain',
    alignItems: 'center',
    justifyContent: 'center'
  },

  text: {
    fontSize: 30,
    textAlign: 'center'
  }
  , responsiveImage: {
    width: '100%',
    height: undefined,
    aspectRatio: 1 / 1,
    alignItems: 'center',
    justifyContent: 'center',

  },

  titulo1: {
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  },

  titulo2: {
    fontSize: 35,
    color: "black",
    fontWeight: 'bold'
  },
  buttonFoto: {
    backgroundColor: '#007aff',
    borderRadius: 50,
    width: 100,
    height: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textLabels: {

    padding: 5,
    alignItems: 'center',
    fontWeight: 'bold',
    color: 'white',
    fontSize: 20
  },
  shadow: {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 10
  }
});